/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

const meDetails = async (): Promise<any> => {
  const token = useUserStore.getState().userToken;
  const userDetails = useUserStore.getState().userDetails;
  if (Object.keys(userDetails).length === 0) {
    try {
      const response = await axios.request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.me}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      });

      useUserStore.setState({userDetails: response.data.data});
      useCompanyStore.setState({
        companyId: response.data.data.company
      });

      return response.data.data;
    } catch (error) {
      console.log('error:', error);
      useCompanyStore.setState({
        companyId: ''
      });

      return await Promise.reject(new Error('Something wrong'));
    }
  }
};

export default meDetails;
